import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PolicyTabService {
  private config = {
    apiUrl: `${environment.PROTOCOL}://${environment.API_URL}:${environment.API_PORT}/api/v1/c8`
  }

  constructor(private http: HttpClient) { }

  updateLiability(body, quoteId, nodeId) {
    return this.http.post<any>(`${this.config.apiUrl}/quote-editor/sync/liability`, body, { params: { quoteId, nodeId } });
  }
}
